<template>
  <modal
    name="product-details-modal"
    :adaptive="true"
    width="90%"
    :maxWidth="1000"
    height="80%"
  >
    <!-- Close Button -->
    <button
      @click="hide('product-details-modal')"
      class="btn-close"
      aria-label="Close"
    >
      <span class="mdi mdi-alpha-x-circle"></span>
    </button>

    <!-- Title -->
    <div class="modal-header">
      <h3 class="modal-title">{{ $t("ecommerce.product.details") }}</h3>
    </div>

    <!-- Product in Sale Section -->
    <div v-if="inSaleProduct" class="modal-body">
      <div class="product-section grid-2">
        <!-- Product Image -->
        <div class="product-image">
          <img
            v-if="Array.isArray(inSaleProduct.pictures) && inSaleProduct.pictures.length > 0"
            :src="storageUrl + inSaleProduct.pictures[0]"
            class="thumbnail"
          />
          <img
            v-else-if="inSaleProduct.pictures"
            :src="storageUrl + inSaleProduct.pictures"
            class="thumbnail"
          />
        </div>

        <!-- Product Info -->
        <div class="product-info">
          <h4 class="fw-title">{{ inSaleProduct.name }}</h4>

          <p v-if="inSaleProduct.category" class="text-muted small">
            <strong>{{ $t("attr.category") }}:</strong>
            {{ inSaleProduct.category.name }}
          </p>

          <p v-if="inSaleProduct.user" class="text-muted small">
            <strong>{{ $t("attr.seller") }}:</strong>
            {{ inSaleProduct.user.firstname }}
          </p>

          <!-- Fixed Price -->
          <div v-if="inSaleProduct.sales_type === 'fixed'" class="price-section">
            <span class="price">
              {{
                inSaleProduct.fixed_price | currency(" DA", 0, { symbolOnLeft: false })
              }}
            </span>
          </div>

          <!-- Auction Section -->
          <div
            v-if="inSaleProduct.sales_type === 'auction' && inSaleProduct.auction_status !== 0"
            class="auction-section"
          >
            <Timer
              :deadline="inSaleProduct.validated"
              :duration="inSaleProduct.duration"
            />
            <p class="price mt-2">
              <strong>{{ $t("sentence.currentBid") }}:</strong>
              <span v-if="inSaleProduct.bids?.length">
                {{
                  inSaleProduct.bids[inSaleProduct.bids.length - 1].price |
                    currency(" DA", 0, { symbolOnLeft: false })
                }}
              </span>
              <span v-else-if="inSaleProduct.starting_price">
                {{ inSaleProduct.starting_price | currency(" DA", 0, { symbolOnLeft: false }) }}
              </span>
              <span v-else>{{ $t("sentence.noBidsForThisProduct") }}</span>
            </p>
          </div>

          <!-- Status -->
          <p v-if="productSelled(inSaleProduct)" class="text-danger">
            {{ $t("sentence.productSoldWaitingForCheckout") }}
          </p>
          <p
            v-if="
              inSaleProduct.sales_type === 'auction' &&
              inSaleProduct.auction_status === 0 &&
              !productSelled(inSaleProduct)
            "
            class="text-danger"
          >
            {{ $t("sidebar.productNotSoldResell") }}
          </p>

          <!-- Attributes -->
          <div class="product-attributes">
            <p v-if="inSaleProduct.state">
              <strong>{{ $t("attr.state") }}:</strong> {{ inSaleProduct.state }}
            </p>
            <p v-if="inSaleProduct.quantity">
              <strong>{{ $t("attr.quantity") }}:</strong> {{ inSaleProduct.quantity }}
            </p>
            <p v-if="inSaleProduct.description">
              <strong>{{ $t("attr.description") }}:</strong> {{ inSaleProduct.description }}
            </p>
          </div>

          <!-- Delivery -->
          <div
            v-if="inSaleProduct.delivery_cost || inSaleProduct.delivery_time"
            class="delivery-info"
          >
            <p v-if="inSaleProduct.delivery_cost">
              <strong>{{ $t("attr.deliveryCost") }}:</strong>
              {{
                inSaleProduct.delivery_cost | currency(" DA", 0, { symbolOnLeft: false })
              }}
            </p>
            <p v-if="inSaleProduct.delivery_time">
              <strong>{{ $t("attr.deliveryTime") }}:</strong>
              {{ inSaleProduct.delivery_time }}
            </p>
          </div>

          <!-- Cash on Delivery -->
          <div v-if="Number(inSaleProduct.cash_on_delivery) === 1">
            <span class="badge badge-info">{{ $t("attr.cashOnDelivery") }}</span>
          </div>

          <!-- Relist Button -->
          <div class="mt-3">
            <router-link
              v-if="
                inSaleProduct.sales_type === 'auction' &&
                inSaleProduct.auction_status === 0 &&
                !productSelled(inSaleProduct)
              "
              class="btn-site"
              :to="{ name: 'test' }"
            >
              {{ $t("sentence.relistProduct") }}
            </router-link>
          </div>
        </div>
      </div>

      <!-- Offers -->
      <div
        v-if="
          (inSaleProduct.sales_type === 'auction' &&
            inSaleProduct.auction_status !== 0) ||
          inSaleProduct.sales_type === 'fixed'
        "
        class="offer-section"
      >
        <h5>{{ $t("sidebar.receivedOffers") }}</h5>

        <table v-if="inSaleProduct.offers?.length" class="table table-striped">
          <thead>
            <tr>
              <th>{{ $t("ecommerce.offer") }}</th>
              <th>{{ $t("main.action") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="offer in inSaleProduct.offers" :key="offer.id">
              <td>
                {{ offer.price | currency(" DA", 0, { symbolOnLeft: false }) }}
              </td>
              <td>
                <button
                  @click="respondOffer(offer.id, true)"
                  class="btn btn-success btn-sm"
                >
                  <i class="mdi mdi-check"></i>
                </button>
                <button
                  @click="respondOffer(offer.id, false)"
                  class="btn btn-danger btn-sm"
                >
                  <i class="mdi mdi-close"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>

        <div
          v-else
          class="alert alert-info text-center"
        >
          {{ $t("sentence.productDidntReceiveAnOffer") }}
        </div>
      </div>
    </div>

    <!-- Close Button -->
    <div class="modal-footer">
      <button
        @click="hide('product-details-modal')"
        class="btn-site btn-danger"
      >
        {{ $t("action.close") }}
      </button>
    </div>
  </modal>
</template>

<style scoped>
/* Modal */
.vm--modal {
  overflow-y: auto !important;
  border-radius: 12px;
}

/* Header */
.modal-header {
  text-align: center;
  margin-bottom: 1rem;
}
.modal-title {
  font-weight: bold;
  color: var(--color-2);
}



/* Layouts */
.grid-2 {
  display: grid;
  grid-template-columns: 1fr 1.2fr;
  gap: 1.5rem;
}
.thumbnail {
  width: 100%;
  max-width: 320px;
  border-radius: 8px;
  object-fit: cover;
}

/* Price */
.price {
  font-size: 1.25rem;
  color: var(--success);
  font-weight: bold;
}

/* Info Blocks */
.text-muted {
  color: var(--gray-500);
}
.product-info p {
  margin: 0.3rem 0;
}

/* Tables */
.table {
  width: 100%;
  border-collapse: collapse;
}
.table th,
.table td {
  padding: 0.5rem;
  text-align: left;
}
.table-striped tbody tr:nth-child(odd) {
  background-color: #f9f9f9;
}

/* Responsive */
@media (max-width: 992px) {
  .grid-2 {
    grid-template-columns: 1fr;
  }
  .modal {
    width: 95% !important;
  }
}
</style>


<script>
import config from "@/config";
import Timer from "../templates/TimerSimple.vue";
export default {
  props: {
    inSaleProduct: {
      type: Object,
    },
    inDeliveryProduct: {
      type: Object,
    },
    newProduct: {
      type: Object,
    },
    inProgressPurchases: {
      type: Object,
    },
    inDeliveryPurchases: {
      type: Object,
    },
  },
  data() {
    return {
      showRating: false,
      showUserRating: false,
      showRatingMessage: "",
      showUserRatingMessage: "",
      storageUrl: config.storageUrl,
      trackingHistory: [],
      loader: false,
      trackingMessage: "",
    };
  },
  components: {
    Timer,
  },
  methods: {
    hide(modalName) {
      event.preventDefault();
      this.trackingHistory = [];
      this.$modal.hide(modalName);
    },
    rates(order) {
      event.preventDefault();
      if (order.status === "received") {
        this.showRating = true;
        return;
      }
      this.showRatingMessage = "Veuillez confirmer la réception du produit";
    },
    ratesUser() {
      event.preventDefault();
      this.showUserRating = true;
    },
    respondOffer(id, response) {
      this.$axios({
        url: "offers/respond/" + id,
        method: "POST",
        data: { response: response },
      })
        .then(() => {
          this.$modal.hide("product-details-modal");
        })
        .catch(function(err) {
          console.log(err.response.data);
        });
    },
    getTrackingHistory(offerId) {
      var self = this;
      self.loader = true;
      this.trackingMessage = "";
      this.$axios({
        url: "orders/status/" + offerId,
        method: "GET",
      })
        .then((response) => {
          self.loader = false;

          if (response.data.message === "267") {
            self.trackingMessage =
              "Aucune information concernant la livraison n'est disponible";
            return;
          }
          var pickupHistory =
            response.data.pickup[response.data.pickup.length - 1];
          var deliveryHistory =
            response.data.delivery[response.data.delivery.length - 1];

          if (
            pickupHistory.status === "order_information_received_by_carrier" &&
            deliveryHistory.status === "order_information_received_by_carrier"
          ) {
            self.trackingHistory = response.data.pickup;
            return;
          }

          if (
            (pickupHistory.status === "livred" ||
              pickupHistory.status === "encaissed" ||
              pickupHistory.status === "payed") &&
            deliveryHistory.status !== "order_information_received_by_carrier"
          ) {
            self.trackingHistory = response.data.delivery;
            return;
          }
        })
        .catch(function() {
          self.loader = false;
        });
    },
    showPopUpConfirmation(id) {
      var self = this;
      this.$modal.show("dialog", {
        title: "Confirmation",
        text: "Vous allez surenchérir sur ce produit.",
        buttons: [
          {
            title: "Cancel",
            handler: () => {
              self.$modal.hide("dialog");
              return false;
            },
          },
          {
            title: "Confirmer",
            handler: () => {
              self.$modal.hide("dialog");
              self.placeBid(id);
            },
          },
        ],
      });
    },
    productSelled(product) {
      if (undefined === product) return false;

      if (product.bids && product.bids.length > 0) {
        var bidsWon = product.bids.filter((b) => b.status === 1);
        if (bidsWon.length > 0) return true;
      }

      if (product.offers && product.offers.length > 0) {
        var offerWon = product.offers.filter((o) => o.status === 1);
        if (offerWon.length > 0) return true;
      }

      return false;
    },
    userWonProduct(product) {
      if (undefined === product) return false;

      var self = this;
      
      if (product.bids && product.bids.length > 0) {
        var bidsWon = product.bids.filter(
          (b) => b.status === 1 && b.user_id === self.user.id
        );
        if (bidsWon.length > 0) return true;
      }

      if (product.offers && product.offers.length > 0) {
        var offerWon = product.offers.filter(
          (o) => o.status === 1 && o.user_id === self.user.id
        );
        if (offerWon.length > 0) return true;
      }

      return false;
    },
    wayOfSales(product) {
      if (undefined === product) return false;

      var self = this;
      
      if (product.bids && product.bids.length > 0) {
        var bidsWon = product.bids.filter(
          (b) => b.status === 1 && b.user_id === self.user.id
        );
        if (bidsWon.length > 0) return "bid";
      }

      if (product.offers && product.offers.length > 0) {
        var offerWon = product.offers.filter(
          (o) => o.status === 1 && o.user_id === self.user.id
        );
        if (offerWon.length > 0) return "offer";
      }

      return "product";
    },
    wonProductId(product) {
      if (undefined === product) return false;

      var self = this;
      
      if (product.bids && product.bids.length > 0) {
        var bidsWon = product.bids.filter(
          (b) => b.status === 1 && b.user_id === self.user.id
        );
        if (bidsWon.length > 0) return bidsWon[0].id;
      }

      if (product.offers && product.offers.length > 0) {
        var offerWon = product.offers.filter(
          (o) => o.status === 1 && o.user_id === self.user.id
        );
        if (offerWon.length > 0) return offerWon[0].id;
      }

      return product.id;
    },
    confirmReception(productId) {
      var self = this;
      self.loader = true;
      this.$axios({
        url: "product/confirmReceipt/" + productId,
        method: "POST",
      })
        .then(() => {
          self.loader = false;
          self.showRating = true;
        })
        .catch(function() {
          self.loader = false;
        });
    },
    onAfterRateProduct(rate) {
      var self = this;
      var data = {
        ratingModel: "User",
        modelToRates: "Product",
        ratingModelId: this.user.id,
        modelToRatesId: this.inDeliveryPurchases?.product.id,
        rates: rate,
      };
      self.loader = true;

      this.$axios({
        url: "ratings/create",
        method: "POST",
        data: data,
      })
        .then(() => {
          self.loader = false;
        })
        .catch(function() {
          self.loader = false;
        });
    },
    onAfterRateUser(rate) {
      event.preventDefault();
      var self = this;
      var data = {
        ratingModel: "User",
        modelToRates: "User",
        ratingModelId: this.user.id,
        modelToRatesId: this.inDeliveryProduct?.orders[0].user_id,
        rates: rate,
      };
      self.loader = true;

      this.$axios({
        url: "ratings/create",
        method: "POST",
        data: data,
      })
        .then(() => {
          self.loader = false;
        })
        .catch(function() {
          self.loader = false;
        });
    },
  },
  computed: {
    currentProduct() {
      if (null !== this.inSaleProduct) {
        return this.inSaleProduct;
      }

      if (null !== this.inDeliveryProduct) {
        return this.inDeliveryProduct;
      }

      if (null !== this.newProduct) {
        return this.newProduct;
      }

      if (null !== this.inProgressPurchases) {
        return this.inProgressPurchases;
      }

      if (null !== this.inDeliveryPurchases) {
        return this.inDeliveryPurchases;
      }

      return null;
    },
    user: {
      get() {
        return this.$store.state.user;
      },
      set(user) {
        this.$store.commit("setUser", { user: user });
      },
    },
  },
};
</script>